<template>
    <footer class="bg-primary text-white px-6 py-20 md:px-24 font-light">
        <div class="max-w-7xl mx-auto flex flex-col md:flex-row gap-16">

            <!-- Colonne gauche : Logo + description -->
            <div class="flex-1 space-y-10">
                <div>
                    <h2 class="text-4xl select-none tracking-wide flex items-baseline font-bold gap-2">
                        <span class="font-handwritten text-5xl leading-none">my</span>
                        <span class="font-josefin "> Profolia</span>
                    </h2>
                    <p class="mt-2 text-gray-300 text-sm max-w-md">
                        Votre vitrine professionnelle en ligne, simple et rapide à créer.
                    </p>
                </div>

                <!-- Liens et réseaux sociaux -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-8 text-sm">
                    <div class="space-y-2">
                        <p class="font-medium text-white uppercase tracking-widest text-xs">Liens utiles</p>
                        <RouterLink to="/" class="hover:text-purple-800 block transition-colors duration-200">Accueil
                        </RouterLink>
                        <RouterLink to="/pricing" class="hover:text-purple-800 block transition-colors duration-200">
                            Tarifs</RouterLink>
                        <RouterLink to="/legal" class="hover:text-purple-800 block transition-colors duration-200">
                            Mentions légales</RouterLink>
                        <RouterLink to="/cgv" class="hover:text-purple-800 block transition-colors duration-200">
                            Conditions générales de vente</RouterLink>
                        <RouterLink to="/cgu" class="hover:text-purple-800 block transition-colors duration-200">
                            Conditions générales d'utilisation</RouterLink>
                        <RouterLink to="/privacy-policy"
                            class="hover:text-purple-800 block transition-colors duration-200">
                            Politique de confidentialité</RouterLink>
                        <RouterLink to="/contact" class="hover:text-purple-800 block transition-colors duration-200">
                            Contact</RouterLink>
                        <RouterLink to="/faq" class="hover:text-purple-800 block transition-colors duration-200">
                            FAQ</RouterLink>

                    </div>

                    <div class="space-y-2">
                        <p class="font-medium text-white uppercase tracking-widest text-xs">Suivez-nous</p>
                        <div class="flex gap-6 mt-2">
                            <a href="https://www.facebook.com/profile.php?id=61579380034647" target="_blank"
                                aria-label="Facebook" class="hover:text-purple-400 transition-colors duration-200">
                                <i class="fab fa-facebook text-2xl"></i>
                            </a>
                            <a href="https://www.instagram.com/myprofolia" target="_blank" aria-label="Instagram"
                                class="hover:text-purple-400 transition-colors duration-200">
                                <i class="fab fa-instagram text-2xl"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Colonne droite : Description supplémentaire ou infos -->
            <div class="flex-1 flex flex-col justify-center text-gray-300 max-w-md text-base leading-relaxed">
                <p>
                    My Profolia facilite la création et la gestion de votre page professionnelle,
                    pour booster votre visibilité en ligne sans effort technique.
                </p>
            </div>
        </div>

        <!-- Bas de page -->
        <div class="text-center text-xs text-gray-400 mt-16 select-none">
            &copy; 2025 My Profolia — Tous droits réservés.
        </div>
    </footer>
</template>
